import axios from 'axios';
import React, { PureComponent, useEffect, useState } from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar, Rectangle, Legend } from 'recharts';
import { usePapaParse } from 'react-papaparse';
import { useCSVDownloader } from 'react-papaparse';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
function DashboardContext({ serverUrl, user, titleOfPage, globalUserId, globalToken   }) {
    const { jsonToCSV } = usePapaParse();
    const { CSVDownloader, Type } = useCSVDownloader();
    const [labDetails, setLabDetails] = useState({})


    const data1 = [
        {
            name: 'Jan-Feb',
            uv: 17,
            amt: 50,
        },
        {
            name: 'Mar-Apr',
            uv: 36,
            amt: 50,
        },
        {
            name: 'May-Jun',
            uv: 20,
            amt: 50,
        },
        {
            name: 'Jul-Aug',
            uv: 17,
            amt: 50,
        },
        {
            name: 'Sep-Oct',
            uv: 25,
            amt: 50,
        },
        {
            name: 'Nov-Dec',
            uv: 19,
            amt: 50,
        }
    ];


    const updateLog = async (data) => {
        const dataSet = {
            "userId": user.userId,
            "changes": data,
        }
        const updateNow = await axios.post(serverUrl + "/users/updateLog", dataSet)
        if (updateNow.status == 200) {
            console.log(updateNow.data)
        } else {
            console.log(updateNow.data)
        }
    }


    const getLabDetails = async () => {
        const findNow = await axios.post(serverUrl + "/labs/get", { "code": user.userId })
        if (findNow.status == 200) {
            // console.log(findNow.data)
            setLabDetails(findNow.data[0])
        } else {
            console.log(findNow.data)
        }
    }

    useEffect(() => {
        getLabDetails()
    }, [])
    return (
        <>
            <div className='h-100 w-100 dataTableSet d-flex flex-column overflow-auto'>
                <div className='w-100 upperMoonsSearchBackground themeTextColor border-0 fs-4 p-0 shadow-sm text-center'>{titleOfPage}</div>
                <div className='p-2 overflow-auto rounded-0 h-100'>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 col-md-12 col-lg-12 col-xl-6 mb-3">
                                {
                                    true ?
                                        <div className='' style={{ width: "100%", aspectRatio: "16/10" }}>
                                            <ResponsiveContainer width="100%" height="100%">
                                                <AreaChart
                                                    width={500}
                                                    height={400}
                                                    data={data1}
                                                    margin={{
                                                        top: 10,
                                                        right: 30,
                                                        left: 0,
                                                        bottom: 0,
                                                    }}
                                                >
                                                    <CartesianGrid strokeDasharray="3 3" />
                                                    <XAxis dataKey="name" />
                                                    <YAxis />
                                                    <Tooltip />
                                                    <Area type="monotone" dataKey="uv" stroke="#8884d8" fill="#8884d8" />
                                                </AreaChart>
                                            </ResponsiveContainer>
                                        </div>
                                        :
                                        <SkeletonTheme highlightColor='#d8733934'>
                                            <Skeleton height={35} className='h-100' style={{ width: "100%", aspectRatio: "16/10" }} />
                                        </SkeletonTheme>
                                }
                            </div>
                            <div className="col-12 col-md-12 col-lg-12 col-xl-6 mb-3">
                                {
                                    labDetails?.warrantyCardInhand ?
                                        <div className='' style={{ width: "100%", aspectRatio: "16/10" }}>
                                            <ResponsiveContainer width="100%" height="100%">
                                                <BarChart
                                                    width={500}
                                                    height={300}
                                                    data={[
                                                        {
                                                            name: 'Stock In Hand',
                                                            "Qty": labDetails.warrantyCardInhand,
                                                        },
                                                        {
                                                            name: 'Issued Warranty Cards',
                                                            "Qty": labDetails.warrantyCardUsed,
                                                        },
                                                        {
                                                            name: 'Total Units Sold',
                                                            "Qty": labDetails.salesOfCrown,
                                                        }
                                                    ]}
                                                    margin={{
                                                        top: 5,
                                                        right: 30,
                                                        left: 20,
                                                        bottom: 5,
                                                    }}
                                                >
                                                    <CartesianGrid strokeDasharray="2 2" />
                                                    <XAxis dataKey="name" />
                                                    <YAxis />
                                                    <Tooltip />
                                                    {/* <Legend verticalAlign="top" height={36}/> */}
                                                    {/* <Bar dataKey="pv" fill="#8884d8" activeBar={<Rectangle fill="pink" stroke="blue" />} /> */}
                                                    <Bar dataKey="Qty" fill="#58595b" activeBar={<Rectangle fill="#ee9a69" stroke="#d87339" />} />
                                                </BarChart>
                                            </ResponsiveContainer>
                                        </div>
                                        :
                                        <SkeletonTheme highlightColor='#d8733934'>
                                            <Skeleton height={35} className='h-100' style={{ width: "100%", aspectRatio: "16/10" }} />
                                        </SkeletonTheme>
                                }
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default DashboardContext